module.exports = __webpack_public_path__ + "img/genai3.501d3d53.png";